import { render, staticRenderFns } from "./expertRecord.vue?vue&type=template&id=2bda9db4&scoped=true"
import script from "./expertRecord.vue?vue&type=script&lang=js"
export * from "./expertRecord.vue?vue&type=script&lang=js"
import style0 from "./expertRecord.vue?vue&type=style&index=0&id=2bda9db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda9db4",
  null
  
)

export default component.exports